import { render, staticRenderFns } from "./tab-customer-firmware.vue?vue&type=template&id=01d35c87&scoped=true"
import script from "./tab-customer-firmware.vue?vue&type=script&lang=js"
export * from "./tab-customer-firmware.vue?vue&type=script&lang=js"
import style0 from "./tab-customer-firmware.vue?vue&type=style&index=0&id=01d35c87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d35c87",
  null
  
)

export default component.exports